<template>
    <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card>
            <v-card-title>
                <span class="headline">{{ form.id == null ? 'Inserisci Ore' : 'Modifica Ore' }}</span>
            </v-card-title>

            <v-card-text>
                <v-form v-model="validForm">
                    <v-row>
                        <v-col cols="4">
                            <!-- <v-select v-model="localForm.project_id" label="Progetto" :items="projects_assigned"
                                 item-value="id" :rules="rules.required">
                                <template v-slot:selection="{ item }">
                                    <v-chip>{{ item | projectName }}</v-chip>
                                </template>
                                <template v-slot:item="{ item }">
                                    <v-chip>{{ item | projectName }}</v-chip>
                                </template>
                            </v-select> -->
{{localForm.project_id}}
                        <item-selector 
                            label="Progetto"
                            v-model="localForm.project"
                            v-bind="{ clearable:true}"
                            item-text="name" 
                            item-key="id" 
                            action="/projects/list"
                        >
                            <template v-slot:selection="{ item }">
                                <v-chip>{{ item | projectName }}</v-chip>
                            </template>
                            <template v-slot:item="{ item }">
                                <v-chip>{{ item | projectName }}</v-chip>
                            </template>
                    </item-selector>
                        </v-col>
                        <v-col cols="3">
                            <v-select v-model="localForm.task_id" label="Task" :items="formTasks" item-text="name"
                                item-value="id" :rules="rules.required"></v-select>
                        </v-col>
                        <v-col cols="3">
                            <v-select v-model="localForm.subtask_id" label="Sottotask" :items="formSubtasks"
                                item-text="name" item-value="id" :rules="rules.required"></v-select>
                        </v-col>
                        <v-col cols="2">
                            <v-text-field v-model="localForm.hours" label="Ore" type="number"
                                placeholder="Inserisci ore" :rules="rules.hours"></v-text-field>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>

            <v-card-actions>
                <v-btn color="red darken-1" text @click="closeDialog">Chiudi</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="green darken-1" text @click="save">Salva</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    props: {
        dialog: {
            type: Boolean,
            required: true,
        },
        projects_assigned: {
            type: Array,
            required: true,
        },
        form: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            localForm: this.form,
            validForm: false,
            rules: {
                required: [(v) => !!v || 'Campo obbligatorio'],
                hours: [(v) => (v && v > 0) || 'Inserisci un numero di ore valido'],
            },
        };
    },
    computed: {
        formTasks() {
            let selectedProject = this.projects_assigned.find(
                project => project.id === this.localForm.project_id
            );
            if (selectedProject && selectedProject.tasks) {
                if (!selectedProject.tasks.some(task => task.id === this.localForm.task_id)) {
                    this.localForm.task_id = null;
                }
            } else {
                this.localForm.task_id = null;
            }
            return selectedProject ? selectedProject.tasks || [] : [];
        },
        formSubtasks() {
            let selectedProject = this.projects_assigned.find(
                project => project.id === this.localForm.project_id
            );
            let selectedTask = selectedProject ? selectedProject.tasks.find(
                task => task.id === this.localForm.task_id
            ) : null;

            if (selectedTask && selectedTask.sub_tasks) {
                if (!selectedTask.sub_tasks.some(subtask => subtask.id === this.localForm.subtask_id)) {
                    this.localForm.subtask_id = null;
                }
            } else {
                this.localForm.subtask_id = null;
            }

            return selectedTask ? selectedTask.sub_tasks || [] : [];
        },
    },
    methods: {
        save() {
            if (this.validForm && this.localForm.id == null) {
                this.$emit('save', this.localForm);
            }
            if (this.validForm && this.localForm.id) {
                this.$emit('update', this.localForm);
            }
        },
        closeDialog() {
            this.$emit('close-dialog')
        }
    },
    filters: {
        projectName: function(item) {
            let jobCode = ( item?.customer?.code && item?.code) ? item.customer.code + '.' + item.code + " ": '';
            console.log(item);
            return jobCode + item?.name;
        }
    },
    watch: {
        localForm: {
            deep: true,
            handler() {
                this.localForm.project_id = this.localForm?.project ? this.localForm.project.id : null;
            }
        }
    },
};
</script>
